module.exports = __webpack_public_path__ + "static/media/appletree1100.3c85e718.jpg";